import { render } from "./menu-top.vue?vue&type=template&id=4e032d6c&scoped=true"
import script from "./menu-top.vue?vue&type=script&lang=js"
export * from "./menu-top.vue?vue&type=script&lang=js"

import "./menu-top.vue?vue&type=style&index=0&id=4e032d6c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4e032d6c"]])

export default __exports__